import {
  last as Rlast,
  descend,
  prop,
  sortBy,
  sortWith,
} from 'ramda';
import { createSelector } from 'reselect';

import { AMOUNT_TYPES } from '@ezugi/constants';
import { DeviceInfo, formatAmount } from '@ezugi/utils';

import { WinnerColorConfig } from '../reducers/config';
import { WinnerListEntry } from '../reducers/round';
import { RootState } from '../types';
import { formatSelector, winnerListConfigSelector } from './config';
import { userCurrencySelector } from './user';

const sortByWinAmount = sortWith<WinnerListEntry>([ descend(prop('WinAmount')) ]);

const sortByAmount = sortBy(prop('amount'));

const defaultColor = {
  amount: -Infinity,
  color: '#DBDBDB',
};

export const winnerListSelector = (state: RootState) => state.round.winnerList ?? [];

export const sortedWinnerListSelector = createSelector(
  winnerListSelector,
  formatSelector,
  userCurrencySelector,
  winnerListConfigSelector,
  (winnerList, format, userCurrency, winnerListConfig) => {
    const sortedList = sortByWinAmount(winnerList);
    const sortedColorConfig = sortByAmount<WinnerColorConfig>(winnerListConfig.colorConfig || []);
    const roundAmount = winnerListConfig.roundAmount && DeviceInfo.isHandheld;

    return sortedList.map(({ WinAmount, ...rest }) => {
      const winnerAmountValueDisplay = formatAmount(
        roundAmount && WinAmount > 1 ? Math.round(WinAmount) : WinAmount,
        AMOUNT_TYPES.BET,
        format,
        userCurrency,
        winnerListConfig.showCurrencySymbol,
        winnerListConfig.showCurrencyCode,
      );
      const configuredColor = sortedColorConfig.find(({ amount }) => WinAmount <= amount);
      const { color } = configuredColor || Rlast(sortedColorConfig) || defaultColor;

      return {
        WinAmount: winnerAmountValueDisplay,
        ...rest,
        style: { color },
      };
    });
  },
);

export const totalWinningsAmountSelector = createSelector(
  winnerListSelector,
  (winnerList) => winnerList.reduce((acc, { WinAmount }) => acc + WinAmount, 0),
);
